import { uiText } from '../i18n/uiText';
import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('UI crashed', error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="app-error-page" style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#f7f7f7', padding: 24 }}>
          <div className="app-error-card" style={{ maxWidth: 520, background: '#fff', borderRadius: 16, boxShadow: '0 10px 30px rgba(0,0,0,0.08)', padding: 28 }}>
            <div style={{ fontSize: 24, fontWeight: 700, color: '#C0392B', marginBottom: 8 }}>{uiText("Что-то пошло не так")}</div>
            <div style={{ color: '#555', lineHeight: 1.5, marginBottom: 16 }}>{uiText("Интерфейс поймал ошибку и остановил рендер, чтобы не показывать пустой экран.")}</div>
            {this.state.error?.message && (
              <div className="app-error-detail" style={{ background: '#faf5f5', border: '1px solid #f1d2d2', borderRadius: 10, padding: 12, fontSize: 13, color: '#7a2b23', marginBottom: 16 }}>
                {this.state.error.message}
              </div>
            )}
            <button type="button" onClick={this.handleReload} className="btn btn-primary">{uiText("Обновить страницу")}</button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
